var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaturnTeal140X85Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140,
    zoomAndPan: "magnify",
    viewBox: "0 0 104.88 63.749997",
    height: 85,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "9ac4aa9f8c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 66 20 L 71 20 L 71 24 L 66 24 Z M 66 20 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "972bfc02bd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "18d7aed3bf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "daaa8ac464"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 82 13 L 89 13 L 89 22 L 82 22 Z M 82 13 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "34ea9e4c0f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0355f96f86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "077a6de80f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 92 9 L 96 9 L 96 15 L 92 15 Z M 92 9 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b1d4cf0172"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0e56d4de45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7668685e9b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 75 24 L 82 24 L 82 28 L 75 28 Z M 75 24 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "706509523b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "16335941fb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c58a3d8c19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 70 29 L 74 29 L 74 31 L 70 31 Z M 70 29 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fb521a6ec7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "97bca987af"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4f6c802e3e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6 7 L 99 7 L 99 57 L 6 57 Z M 6 7 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4e3f5502fb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "044c4f550d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3004177d95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 46 29 L 58 29 L 58 35 L 46 35 Z M 46 29 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9dad294a42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2d1582c6fe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "15d376a0ce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 51 18 L 62 18 L 62 24 L 51 24 Z M 51 18 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "99e6842aa5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c33359e1f4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c97aa58817"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40 10 L 51 10 L 51 17 L 40 17 Z M 40 10 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d2dd61e9bf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "88eeb56291"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "65335d6e0f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 58 20 L 69 20 L 69 26 L 58 26 Z M 58 20 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a75d170ed4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b792339554"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cf59f427df"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36 32 L 45 32 L 45 35 L 36 35 Z M 36 32 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "66553d0e14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6fa0be7f6c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2f83e38c20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49 27 L 57 27 L 57 31 L 49 31 Z M 49 27 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "38e1a1af98"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "db79916377"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1e33e39470"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 44 24 L 49 24 L 49 27 L 44 27 Z M 44 24 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7f112bf5c2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c622c80b87"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e25800a39d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 37 34 L 45 34 L 45 38 L 37 38 Z M 37 34 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "df977ac522"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "66e4338ee3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "22afd98709"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 59 24 L 65 24 L 65 28 L 59 28 Z M 59 24 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a9830a1477"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ce3094f589"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5dcc6cf658"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 54 13 L 59 13 L 59 17 L 54 17 Z M 54 13 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c6c7569ebd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "44bff89112"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "87cc4da415"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 38 15 L 41 15 L 41 18 L 38 18 Z M 38 15 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d912ce4ff7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3fada31982"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c54adf363a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 61 15 L 66 15 L 66 19 L 61 19 Z M 61 15 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "30f11b3c8f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bd32fda15f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9e0a1d8a5f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 34 34 L 38 34 L 38 37 L 34 37 Z M 34 34 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a7e3c775ee"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "111a98db31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ea38d658ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 34 28 L 39 28 L 39 30 L 34 30 Z M 34 28 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2c3e5afa5c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5a79a5a2ae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "85c76d0c3f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 35 22 L 38 22 L 38 25 L 35 25 Z M 35 22 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b1d967dfcc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b32e19013f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d565cf2932"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 43 33 L 65 33 L 65 44 L 43 44 Z M 43 33 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dc3617325e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5b02980751"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "da0d1ff135"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11 36 L 26 36 L 26 53 L 11 53 Z M 11 36 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "863ac0365c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1d9ff59084"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2eae21c78c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25 47 L 35 47 L 35 51 L 25 51 Z M 25 47 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9e8aa01afd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "393f4d718f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b72c37123f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19 42 L 24 42 L 24 49 L 19 49 Z M 19 42 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "54da436536"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c7af9cec9d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4ba22e050f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14 45 L 17 45 L 17 51 L 14 51 Z M 14 45 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2b05c8181e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b226e516fc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7287188cdc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8 49 L 12 49 L 12 55 L 8 55 Z M 8 49 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "11d513f3f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "46efcd26dc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bcac4e10b8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 39 45 L 43 45 L 43 47 L 39 47 Z M 39 45 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "572399a378"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a67dab4bf1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ceec40dc91"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 45 41 L 71 41 L 71 52 L 45 52 Z M 45 41 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3c6b8bf03e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4ccb3e5184"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5810939f5f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 47 48 L 54 48 L 54 51 L 47 51 Z M 47 48 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dcb85c4fbf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "281312c6c0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4f088c359c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 62 42 L 66 42 L 66 44 L 62 44 Z M 62 42 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "23aed9de80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b007fbd68d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a65a903328"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69 39 L 72 39 L 72 41 L 69 41 Z M 69 39 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e7aae47d17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f1fa7aaab0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.726562 31.792969 L 89.542969 -10.351562 L 108.613281 31.859375 L 15.347656 74.003906 Z M -3.726562 31.792969 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9ac4aa9f8c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#972bfc02bd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#18d7aed3bf)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 70.453125 20.890625 C 69.214844 21.761719 68.152344 22.867188 66.769531 23.515625 C 67.429688 22.625 69.808594 20.890625 70.453125 20.890625 Z M 70.453125 20.890625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#daaa8ac464)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#34ea9e4c0f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0355f96f86)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 84.132812 13.730469 C 85.207031 13.449219 86.121094 13.433594 87.003906 13.722656 C 88.054688 14.066406 88.535156 15.3125 88.007812 16.347656 C 87.375 17.582031 86.679688 18.765625 85.449219 19.558594 C 84.410156 20.230469 83.457031 21.027344 82.414062 21.714844 C 82.496094 21.359375 82.769531 21.167969 83.007812 20.96875 C 83.613281 20.453125 84.199219 19.914062 84.851562 19.472656 C 86.003906 18.6875 86.835938 17.648438 87.457031 16.421875 C 87.5625 16.21875 87.671875 16.007812 87.730469 15.789062 C 87.964844 14.882812 87.460938 14.121094 86.53125 14 C 86.109375 13.945312 85.675781 13.980469 85.246094 13.953125 C 84.933594 13.929688 84.597656 14.074219 84.132812 13.734375 Z M 84.132812 13.730469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#077a6de80f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b1d4cf0172)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0e56d4de45)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 93.34375 14.292969 C 93.726562 13.890625 94.105469 13.488281 94.488281 13.085938 C 94.929688 12.628906 95.074219 12.070312 95.054688 11.449219 C 95.027344 10.683594 94.691406 10.136719 93.96875 9.828125 C 93.613281 9.675781 93.199219 9.628906 92.894531 9.335938 C 93.769531 9.058594 94.976562 9.644531 95.320312 10.585938 C 95.792969 11.886719 95.65625 13.238281 93.347656 14.292969 Z M 93.34375 14.292969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7668685e9b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#706509523b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#16335941fb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 75.871094 27.1875 C 76.335938 26.515625 79.304688 24.746094 81.097656 24.074219 C 80.6875 24.644531 76.609375 27.074219 75.871094 27.1875 Z M 75.871094 27.1875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c58a3d8c19)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fb521a6ec7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#97bca987af)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 73.589844 29.40625 C 72.683594 29.855469 71.742188 30.222656 70.792969 30.839844 C 71.367188 29.992188 72.421875 29.441406 73.589844 29.40625 Z M 73.589844 29.40625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4f6c802e3e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4e3f5502fb)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#044c4f550d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 61.371094 11.675781 C 62.722656 12.140625 63.949219 12.707031 65.089844 13.453125 C 65.695312 13.847656 66.257812 13.871094 66.953125 13.609375 C 73.1875 11.242188 79.496094 9.105469 86.058594 7.820312 C 88.492188 7.34375 90.9375 6.992188 93.433594 7.097656 C 94.496094 7.140625 95.535156 7.296875 96.515625 7.738281 C 97.878906 8.351562 98.453125 9.355469 98.253906 10.84375 C 98.152344 11.609375 97.851562 12.304688 97.464844 12.964844 C 95.90625 15.628906 93.738281 17.75 91.449219 19.753906 C 86.859375 23.757812 81.855469 27.1875 76.695312 30.398438 C 75.953125 30.859375 75.632812 31.347656 75.585938 32.269531 C 75.148438 41.019531 70.832031 47.367188 63.328125 51.5625 C 58.085938 54.496094 52.4375 55.191406 46.546875 54.019531 C 43.589844 53.429688 40.882812 52.238281 38.402344 50.539062 C 37.769531 50.105469 37.25 50.007812 36.5 50.289062 C 30.902344 52.382812 25.242188 54.277344 19.371094 55.46875 C 16.75 56.003906 14.109375 56.410156 11.414062 56.308594 C 10.257812 56.269531 9.105469 56.140625 8.054688 55.582031 C 6.769531 54.902344 6.308594 54.011719 6.488281 52.570312 C 6.578125 51.867188 6.839844 51.230469 7.179688 50.617188 C 8.285156 48.632812 9.796875 46.976562 11.414062 45.410156 C 15.007812 41.933594 19.035156 39.003906 23.136719 36.167969 C 24.84375 34.984375 26.644531 33.933594 28.308594 32.683594 C 28.742188 32.355469 28.957031 32.015625 28.988281 31.460938 C 29.101562 29.332031 29.550781 27.253906 30.324219 25.28125 C 31.503906 22.269531 33.207031 19.5625 35.546875 17.300781 C 41.765625 11.304688 49.160156 9.136719 57.648438 10.578125 C 58.953125 10.796875 60.222656 11.167969 61.375 11.675781 Z M 50.679688 10.894531 C 49.308594 10.875 48 11.21875 46.683594 11.539062 C 46.09375 11.683594 45.574219 11.878906 45.40625 12.867188 C 45.136719 11.964844 44.761719 12.132812 44.378906 12.308594 C 43.921875 12.515625 44.121094 12.828125 44.226562 13.144531 C 44.300781 13.375 44.464844 13.613281 44.273438 13.878906 C 43.890625 13.703125 43.863281 13.332031 43.707031 13.058594 C 43.601562 12.871094 43.484375 12.71875 43.246094 12.769531 C 43.011719 12.824219 42.824219 12.941406 42.765625 13.203125 C 42.714844 13.429688 42.921875 13.695312 42.699219 13.925781 C 42.117188 13.3125 42.109375 13.300781 41.441406 13.648438 C 39.941406 14.425781 38.578125 15.414062 37.292969 16.507812 C 34.320312 19.050781 32.148438 22.175781 30.8125 25.84375 C 30.019531 28.023438 29.636719 30.296875 29.597656 32.648438 C 29.527344 36.648438 30.578125 40.300781 32.640625 43.695312 C 33.183594 44.582031 33.195312 44.558594 34.230469 44.253906 C 40.222656 42.472656 46.003906 40.132812 51.707031 37.609375 C 56.6875 35.40625 61.566406 32.980469 66.335938 30.351562 C 68.761719 29.015625 71.148438 27.605469 73.484375 26.109375 C 73.957031 25.808594 74.125 25.496094 73.882812 24.972656 C 73.578125 24.308594 73.332031 23.621094 73.015625 22.964844 C 70.457031 17.652344 66.300781 14.121094 60.847656 12.046875 C 60.042969 11.738281 59.367188 11.84375 58.773438 12.46875 C 58.179688 13.09375 57.453125 13.558594 56.75 14.050781 C 55.425781 14.976562 54.144531 15.964844 52.742188 16.78125 C 52.53125 16.902344 52.167969 17.070312 52.355469 17.367188 C 52.554688 17.683594 52.886719 17.433594 53.140625 17.316406 C 53.25 17.269531 53.308594 17.117188 53.410156 17.039062 C 53.5625 16.921875 53.722656 16.785156 53.964844 17 C 53.730469 17.4375 53.316406 17.617188 52.882812 17.765625 C 52.101562 18.035156 51.316406 18.285156 50.539062 18.566406 C 49.71875 18.859375 48.960938 19.269531 48.230469 19.761719 C 48.511719 20.101562 48.941406 19.71875 49.152344 20.136719 C 48.65625 20.417969 48.117188 20.324219 47.601562 20.359375 C 47.34375 20.375 47.078125 20.285156 46.824219 20.425781 C 45.832031 20.988281 44.839844 21.550781 43.539062 21.882812 C 44.21875 22.203125 44.785156 22.058594 45.390625 22.382812 C 44.636719 22.628906 44 22.601562 43.425781 22.394531 C 42.234375 21.96875 41.078125 22.347656 39.902344 22.421875 C 39.742188 22.433594 39.554688 22.480469 39.574219 22.707031 C 39.585938 22.882812 39.695312 23.007812 39.875 23.050781 C 39.996094 23.074219 40.140625 23.011719 40.222656 23.160156 C 39.746094 23.871094 39.429688 23.910156 39.109375 23.144531 C 38.875 22.582031 38.640625 22.578125 38.171875 22.699219 C 37.828125 22.785156 37.4375 23.027344 37.09375 22.65625 C 37.214844 22.320312 37.488281 22.394531 37.695312 22.363281 C 38.480469 22.246094 39.265625 22.164062 40.039062 21.96875 C 43.289062 21.152344 46.363281 19.871094 49.335938 18.355469 C 52.3125 16.839844 55.042969 14.925781 57.742188 12.96875 C 58.238281 12.609375 58.625 12.128906 59.078125 11.578125 C 58.097656 11.226562 57.1875 11.082031 56.28125 10.964844 C 54.410156 10.722656 52.539062 10.539062 50.664062 10.90625 L 50.675781 10.902344 Z M 21.207031 44.304688 C 21.289062 43.992188 21.515625 43.886719 21.722656 43.835938 C 22.375 43.671875 22.78125 43.222656 23.1875 42.730469 C 23.820312 41.96875 24.542969 41.289062 25.3125 40.664062 C 26.464844 39.726562 27.640625 38.8125 28.867188 37.972656 C 29.277344 37.691406 29.410156 37.386719 29.300781 36.894531 C 29.089844 35.957031 28.992188 35 28.9375 34.039062 C 28.894531 33.3125 28.789062 33.253906 28.199219 33.628906 C 23.527344 36.617188 18.925781 39.710938 14.675781 43.292969 C 12.554688 45.082031 10.523438 46.96875 8.828125 49.183594 C 8.183594 50.027344 7.617188 50.914062 7.273438 51.933594 C 6.691406 53.660156 7.210938 54.730469 8.941406 55.335938 C 9.222656 55.433594 9.511719 55.503906 9.804688 55.550781 C 10.683594 55.703125 11.574219 55.773438 12.46875 55.742188 C 14.75 55.671875 17.003906 55.363281 19.234375 54.898438 C 26.003906 53.484375 32.511719 51.214844 38.9375 48.722656 C 41.152344 47.863281 43.347656 46.953125 45.527344 46.007812 C 50.371094 43.90625 55.148438 41.660156 59.84375 39.246094 C 66.273438 35.941406 72.566406 32.402344 78.632812 28.464844 C 82.234375 26.128906 85.746094 23.667969 89.066406 20.941406 C 91.496094 18.949219 93.835938 16.867188 95.792969 14.390625 C 96.558594 13.421875 97.175781 12.378906 97.539062 11.191406 C 97.945312 9.84375 97.492188 8.859375 96.183594 8.304688 C 95.574219 8.042969 94.941406 7.871094 94.277344 7.792969 C 92.660156 7.605469 91.042969 7.660156 89.4375 7.871094 C 82.980469 8.710938 76.824219 10.683594 70.722656 12.84375 C 70.511719 12.921875 70.191406 12.960938 70.160156 13.195312 C 70.085938 13.761719 69.613281 13.8125 69.246094 13.980469 C 68.765625 14.199219 68.257812 14.355469 67.765625 14.539062 C 67.585938 14.605469 67.34375 14.652344 67.410156 14.917969 C 67.457031 15.113281 67.648438 15.230469 67.835938 15.300781 C 68.039062 15.375 68.222656 15.261719 68.40625 15.191406 C 69.207031 14.886719 70.019531 14.605469 70.804688 14.265625 C 74.683594 12.574219 78.785156 11.742188 82.945312 11.140625 C 84.511719 10.917969 86.09375 10.816406 87.679688 10.828125 C 89.082031 10.839844 90.445312 11.085938 91.726562 11.667969 C 93.066406 12.273438 93.390625 13.695312 92.464844 14.777344 C 91.78125 15.570312 89.800781 16.445312 88.59375 16.457031 C 89.5 15.945312 90.371094 15.480469 91.214844 14.972656 C 91.851562 14.589844 92.46875 14.117188 92.34375 13.265625 C 92.210938 12.382812 91.46875 12.09375 90.714844 11.863281 C 89.175781 11.398438 87.609375 11.332031 86.011719 11.398438 C 83.027344 11.519531 80.117188 12.101562 77.210938 12.726562 C 74.175781 13.378906 71.328125 14.605469 68.332031 15.695312 C 69.011719 16.398438 69.648438 17.011719 70.234375 17.671875 C 70.546875 18.03125 70.824219 18.089844 71.261719 17.921875 C 73.207031 17.171875 75.234375 16.699219 77.285156 16.332031 C 78.714844 16.078125 80.152344 15.851562 81.613281 16.03125 C 83.6875 16.285156 84.210938 17.46875 83.011719 19.179688 C 82.230469 20.296875 81.238281 21.214844 80.199219 22.089844 C 78.054688 23.910156 75.710938 25.445312 73.339844 26.941406 C 67.242188 30.785156 60.835938 34.046875 54.3125 37.089844 C 51.414062 38.441406 48.46875 39.691406 45.492188 40.871094 C 40.890625 42.6875 36.265625 44.445312 31.464844 45.660156 C 28.746094 46.347656 26.015625 47.015625 23.160156 46.601562 C 22.386719 46.488281 22.136719 46.421875 22 45.6875 C 21.90625 45.195312 21.574219 45.132812 21.222656 45.042969 C 21.386719 44.65625 21.726562 44.609375 21.9375 44.40625 C 22 44.34375 22.003906 44.292969 21.925781 44.238281 C 21.703125 44.199219 21.511719 44.445312 21.203125 44.308594 Z M 52.238281 53.128906 C 52.621094 53.953125 52.621094 53.980469 53.554688 53.882812 C 61.578125 53.035156 67.832031 49.320312 72.09375 42.386719 C 72.738281 41.34375 73.21875 40.21875 73.628906 39.0625 C 73.832031 38.492188 73.265625 38.957031 73.195312 38.671875 C 73.640625 38.121094 74.222656 37.617188 74.390625 36.828125 C 74.710938 35.371094 74.949219 33.902344 75.003906 32.410156 C 75.011719 32.160156 75.101562 31.882812 74.789062 31.609375 C 71.886719 33.320312 68.976562 35.0625 65.992188 36.671875 C 63 38.285156 59.988281 39.859375 56.945312 41.375 C 53.902344 42.894531 50.808594 44.292969 47.71875 45.707031 C 44.648438 47.109375 41.484375 48.292969 38.203125 49.699219 C 42.070312 52.347656 46.105469 53.710938 50.492188 53.925781 C 50.710938 53.527344 50.300781 53.253906 50.5625 52.957031 C 50.648438 53.035156 50.726562 53.09375 50.78125 53.167969 C 51.550781 54.203125 51.6875 54.199219 52.234375 53.128906 Z M 74.691406 25.308594 C 77.269531 23.609375 79.65625 21.910156 81.714844 19.792969 C 82.105469 19.390625 82.46875 18.960938 82.730469 18.453125 C 83.269531 17.390625 82.984375 16.816406 81.824219 16.636719 C 81.101562 16.523438 80.378906 16.550781 79.652344 16.621094 C 77.007812 16.871094 74.464844 17.589844 71.910156 18.253906 C 71.082031 18.472656 71.046875 18.574219 71.582031 19.3125 C 72.621094 20.742188 73.4375 22.289062 74.113281 23.914062 C 74.289062 24.339844 74.464844 24.765625 74.6875 25.304688 Z M 23.523438 45.996094 C 23.730469 46.089844 24.0625 46.105469 24.394531 46.113281 C 26.972656 46.191406 29.425781 45.511719 31.894531 44.902344 C 32.355469 44.789062 32.355469 44.503906 32.136719 44.152344 C 31.125 42.546875 30.359375 40.828125 29.800781 39.011719 C 29.617188 38.417969 29.464844 38.371094 28.953125 38.726562 C 27.109375 40.007812 25.3125 41.351562 23.785156 43.015625 C 23.378906 43.453125 22.996094 43.910156 22.769531 44.472656 C 22.464844 45.214844 22.679688 45.683594 23.523438 45.996094 Z M 23.523438 45.996094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3004177d95)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9dad294a42)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2d1582c6fe)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 57.824219 29.699219 C 57.355469 30.285156 56.878906 30.445312 56.417969 30.5625 C 53.824219 31.214844 51.429688 32.414062 48.921875 33.289062 C 48.210938 33.539062 47.546875 33.886719 46.847656 34.453125 C 46.828125 33.902344 47.109375 33.710938 47.367188 33.582031 C 48.535156 32.984375 49.625 32.246094 50.855469 31.765625 C 52.171875 31.257812 53.398438 30.539062 54.792969 30.214844 C 55.714844 30 56.636719 29.78125 57.824219 29.699219 Z M 57.824219 29.699219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#15d376a0ce)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#99e6842aa5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c33359e1f4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 61.449219 18.34375 C 60.910156 18.980469 60.277344 19.511719 59.539062 19.886719 C 58.480469 20.421875 57.441406 21.0625 56.308594 21.371094 C 54.894531 21.753906 53.574219 22.253906 52.355469 23.066406 C 52.042969 23.269531 51.636719 23.335938 51.128906 23.519531 C 51.332031 22.9375 51.730469 22.84375 52.050781 22.660156 C 53.507812 21.820312 55.078125 21.210938 56.574219 20.449219 C 58.15625 19.648438 59.777344 18.9375 61.449219 18.339844 Z M 61.449219 18.34375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c97aa58817)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d2dd61e9bf)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#88eeb56291)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 40.375 15.628906 C 41.226562 15.40625 42.085938 15.195312 42.933594 14.949219 C 44.027344 14.628906 45.097656 14.246094 46.019531 13.535156 C 46.433594 13.214844 46.988281 13.226562 47.457031 12.96875 C 48.578125 12.34375 49.503906 11.425781 50.675781 10.894531 L 50.667969 10.898438 C 50.660156 10.992188 50.683594 11.152344 50.636719 11.171875 C 49.980469 11.484375 49.753906 12.386719 48.914062 12.449219 C 48.882812 12.449219 48.84375 12.472656 48.828125 12.496094 C 48.164062 13.578125 47.042969 13.824219 45.933594 14.09375 C 45.84375 14.117188 45.769531 14.191406 45.648438 14.265625 C 45.714844 14.566406 46.089844 14.304688 46.179688 14.597656 C 45.882812 14.917969 45.484375 14.808594 45.113281 14.789062 C 44.8125 14.769531 44.5 14.769531 44.292969 15.003906 C 43.976562 15.363281 43.992188 15.378906 43.652344 15.300781 C 42.992188 15.144531 42.835938 15.253906 42.722656 16.015625 C 42.003906 15.390625 41.226562 15.773438 40.464844 15.8125 C 40.4375 15.75 40.40625 15.691406 40.378906 15.632812 Z M 40.375 15.628906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#65335d6e0f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a75d170ed4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b792339554)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 65.761719 21.339844 C 66.484375 21.507812 66.960938 21.457031 67.367188 20.925781 C 67.71875 20.46875 68.042969 20.910156 68.53125 21.292969 C 67.628906 21.183594 67.140625 21.542969 66.757812 22.078125 C 66.550781 22.367188 66.214844 22.433594 65.925781 22.578125 C 65.398438 22.839844 64.828125 23.046875 64.488281 23.574219 C 64.34375 23.796875 64.085938 23.765625 63.890625 23.867188 C 63.125 24.246094 62.144531 24.257812 61.671875 25.152344 C 61.640625 25.21875 61.496094 25.273438 61.421875 25.257812 C 60.574219 25.066406 59.890625 25.535156 59.160156 25.796875 C 59.015625 25.851562 58.867188 25.953125 58.65625 25.785156 C 58.964844 25.464844 59.398438 25.402344 59.753906 25.214844 C 60.058594 25.050781 60.488281 25.066406 60.582031 24.605469 C 60.597656 24.542969 60.746094 24.445312 60.800781 24.464844 C 61.839844 24.808594 62.257812 23.800781 62.964844 23.445312 C 63.371094 23.242188 63.582031 22.65625 64.203125 23.050781 C 64.347656 23.144531 64.570312 22.96875 64.742188 22.871094 C 65.058594 22.691406 65.375 22.515625 65.691406 22.34375 C 66.191406 22.082031 66.191406 22.085938 65.765625 21.339844 Z M 65.761719 21.339844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cf59f427df)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#66553d0e14)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6fa0be7f6c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 36.011719 34.320312 C 38.574219 33.652344 41.140625 32.980469 43.707031 32.328125 C 43.882812 32.28125 44.105469 32.316406 44.273438 32.578125 C 43.757812 33.015625 43.082031 32.683594 42.527344 32.921875 C 41.988281 33.152344 41.394531 33.257812 40.824219 33.417969 C 40.242188 33.582031 39.628906 33.648438 38.9375 33.96875 C 39.882812 34.585938 40.496094 33.351562 41.382812 33.90625 C 40.898438 34.070312 40.515625 34.203125 40.15625 34.382812 C 39.609375 34.652344 39.03125 34.792969 38.558594 34.207031 C 38.363281 33.96875 38.132812 34.101562 37.917969 34.144531 C 37.3125 34.277344 36.710938 34.425781 36.101562 34.570312 C 36.074219 34.488281 36.042969 34.402344 36.011719 34.320312 Z M 36.011719 34.320312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2f83e38c20)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#38e1a1af98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#db79916377)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 56.613281 27.878906 C 55.667969 28.308594 54.742188 28.78125 53.777344 29.15625 C 52.679688 29.585938 51.519531 29.855469 50.453125 30.375 C 50.3125 30.441406 50.128906 30.546875 50.023438 30.359375 C 49.917969 30.179688 50.066406 30.042969 50.21875 29.976562 C 50.640625 29.796875 51.0625 29.601562 51.5 29.480469 C 52.921875 29.074219 54.355469 28.726562 55.605469 27.875 C 55.855469 27.703125 56.160156 27.507812 56.613281 27.878906 Z M 56.613281 27.878906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1e33e39470)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7f112bf5c2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c622c80b87)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 48.921875 24.71875 C 47.5 25.738281 46.015625 26.554688 44.226562 26.5625 C 44.1875 26.332031 44.277344 26.222656 44.402344 26.1875 C 45.917969 25.714844 47.355469 25.019531 48.921875 24.71875 Z M 48.921875 24.71875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e25800a39d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#df977ac522)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#66e4338ee3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 44.820312 34.929688 C 42.476562 35.941406 40.027344 36.59375 37.558594 37.183594 C 38.160156 36.785156 38.769531 36.449219 39.492188 36.335938 C 40.53125 36.171875 41.542969 35.960938 42.484375 35.417969 C 43.179688 35.023438 44.003906 34.914062 44.820312 34.929688 Z M 44.820312 34.929688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#22afd98709)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a9830a1477)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ce3094f589)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 64.671875 24.5 C 62.964844 25.730469 61.085938 26.617188 59.070312 27.242188 C 59.882812 26.59375 60.871094 26.28125 61.773438 25.804688 C 62.703125 25.316406 63.625 24.816406 64.550781 24.320312 C 64.589844 24.378906 64.628906 24.441406 64.671875 24.5 Z M 64.671875 24.5 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5dcc6cf658)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c6c7569ebd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#44bff89112)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 58.796875 13.339844 C 58.335938 14.769531 57.121094 15.160156 55.996094 15.683594 C 55.679688 15.828125 55.378906 16.019531 55.066406 16.195312 C 54.878906 15.859375 55.109375 15.730469 55.292969 15.640625 C 55.792969 15.394531 56.304688 15.179688 56.8125 14.953125 C 57.300781 14.738281 57.746094 14.503906 57.90625 13.921875 C 58.027344 13.492188 58.378906 13.332031 58.796875 13.339844 Z M 58.796875 13.339844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#87cc4da415)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d912ce4ff7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3fada31982)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 40.460938 15.8125 C 40.414062 16.257812 40.367188 16.703125 40.316406 17.167969 C 39.957031 17.105469 40.019531 16.835938 39.972656 16.632812 C 39.925781 16.425781 39.996094 16.125 39.675781 16.089844 C 39.367188 16.054688 39.105469 16.167969 38.917969 16.445312 C 38.738281 16.703125 38.757812 17.085938 38.414062 17.25 C 38.203125 16.34375 38.367188 15.980469 39.132812 15.800781 C 39.539062 15.707031 39.933594 15.476562 40.375 15.632812 C 40.402344 15.691406 40.433594 15.753906 40.460938 15.8125 Z M 40.460938 15.8125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c54adf363a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#30f11b3c8f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bd32fda15f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 61.445312 18.339844 C 62.304688 17.433594 63.160156 16.523438 64.023438 15.625 C 64.359375 15.277344 64.691406 15.238281 65.0625 15.820312 C 64.339844 15.765625 64 16.257812 63.574219 16.625 C 62.886719 17.222656 62.347656 18.007812 61.449219 18.34375 Z M 61.445312 18.339844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9e0a1d8a5f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a7e3c775ee)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#111a98db31)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 34.699219 35.222656 C 34.914062 35.167969 34.964844 35.34375 35.050781 35.472656 C 35.226562 35.726562 35.496094 35.722656 35.628906 35.523438 C 36.199219 34.65625 36.875 34.941406 37.578125 35.28125 C 37.5625 35.3125 37.546875 35.363281 37.53125 35.363281 C 36.761719 35.378906 36.066406 35.523438 35.40625 36.023438 C 35.011719 36.328125 34.671875 35.925781 34.695312 35.222656 Z M 34.699219 35.222656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ea38d658ac)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2c3e5afa5c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5a79a5a2ae)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 38.117188 28.339844 C 37.738281 28.59375 37.308594 28.570312 36.902344 28.632812 C 36.351562 28.71875 35.777344 28.691406 35.277344 29.003906 C 35.15625 29.078125 35.023438 29.101562 34.945312 28.949219 C 34.878906 28.816406 34.9375 28.6875 35.050781 28.605469 C 35.15625 28.53125 35.277344 28.457031 35.402344 28.433594 C 36.296875 28.261719 37.203125 28.246094 38.117188 28.339844 Z M 38.117188 28.339844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#85c76d0c3f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b1d967dfcc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b32e19013f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 37.648438 24.171875 C 37.128906 24.324219 36.964844 24.011719 36.769531 23.761719 C 36.613281 23.5625 36.554688 23.277344 36.246094 23.210938 C 35.863281 23.125 36 22.878906 36.132812 22.695312 C 36.304688 22.449219 36.53125 22.492188 36.707031 22.699219 C 37.089844 23.140625 37.09375 23.8125 37.648438 24.171875 Z M 37.648438 24.171875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d565cf2932)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dc3617325e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5b02980751)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 64.292969 33.933594 C 64.003906 34.472656 63.589844 34.601562 63.210938 34.789062 C 58.820312 36.921875 54.4375 39.054688 50.050781 41.191406 C 49.929688 41.246094 49.804688 41.371094 49.699219 41.359375 C 48.605469 41.203125 47.78125 41.925781 46.820312 42.203125 C 46.09375 42.414062 45.378906 42.675781 44.660156 42.910156 C 44.453125 42.976562 44.238281 43.082031 43.992188 42.945312 C 44.171875 42.578125 44.515625 42.507812 44.796875 42.378906 C 46.515625 41.617188 48.234375 40.851562 49.960938 40.117188 C 51.726562 39.367188 53.375 38.394531 55.089844 37.5625 C 57.609375 36.339844 60.210938 35.285156 62.78125 34.171875 C 63.214844 33.984375 63.671875 33.765625 64.292969 33.9375 Z M 64.292969 33.933594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#da0d1ff135)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#863ac0365c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1d9ff59084)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 23.898438 50.632812 C 23.335938 50.988281 22.785156 51.113281 22.261719 51.296875 C 21.011719 51.722656 19.761719 52.136719 18.5 52.53125 C 16.339844 53.199219 14.449219 52.546875 12.769531 51.195312 C 11.597656 50.257812 11.34375 48.992188 11.984375 47.628906 C 12.609375 46.296875 13.554688 45.179688 14.671875 44.242188 C 17.960938 41.46875 21.496094 39.050781 25.3125 37.050781 C 25.480469 36.957031 25.648438 36.832031 25.925781 36.90625 C 25.898438 37.257812 25.574219 37.335938 25.359375 37.464844 C 23.742188 38.484375 22.058594 39.402344 20.492188 40.503906 C 18.144531 42.164062 15.921875 43.976562 13.851562 45.976562 C 13.371094 46.4375 13.003906 46.984375 12.667969 47.558594 C 11.980469 48.734375 12.085938 49.929688 13.164062 50.746094 C 14.566406 51.804688 16.144531 52.492188 17.96875 52.027344 C 19.726562 51.578125 21.472656 51.085938 23.226562 50.617188 C 23.40625 50.570312 23.585938 50.4375 23.898438 50.636719 Z M 23.898438 50.632812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2eae21c78c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9e8aa01afd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#393f4d718f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 25.671875 50.433594 C 26.425781 49.726562 33.777344 47.441406 34.941406 47.511719 C 34.171875 48.0625 33.394531 48.148438 32.703125 48.421875 C 31.941406 48.722656 31.15625 48.96875 30.386719 49.261719 C 29.648438 49.542969 28.898438 49.78125 28.125 49.933594 C 27.375 50.082031 26.636719 50.316406 25.671875 50.429688 Z M 25.671875 50.433594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b72c37123f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#54da436536)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c7af9cec9d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 22.792969 42.203125 C 22.402344 42.433594 22.007812 42.660156 21.617188 42.894531 C 21.039062 43.234375 20.582031 43.699219 20.214844 44.257812 C 19.71875 45.019531 19.503906 45.839844 19.902344 46.691406 C 20.316406 47.585938 21.183594 47.777344 22.046875 47.867188 C 22.433594 47.910156 22.832031 47.804688 23.226562 47.769531 C 23.355469 47.757812 23.511719 47.753906 23.558594 47.902344 C 23.628906 48.117188 23.460938 48.199219 23.300781 48.238281 C 22.128906 48.535156 21.003906 48.457031 20.027344 47.667969 C 19.355469 47.125 19.160156 46.378906 19.214844 45.539062 C 19.316406 44.03125 21.257812 42.074219 22.792969 42.199219 Z M 22.792969 42.203125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4ba22e050f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2b05c8181e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b226e516fc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 15.960938 45.15625 C 14.109375 48.238281 15.070312 49.261719 16.378906 50.503906 C 16.164062 50.800781 15.902344 50.695312 15.707031 50.523438 C 13.8125 48.832031 14.15625 46.34375 15.78125 45.125 C 15.796875 45.113281 15.839844 45.132812 15.960938 45.15625 Z M 15.960938 45.15625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7287188cdc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#11d513f3f0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#46efcd26dc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 11.835938 54.34375 C 10.796875 54.605469 9.496094 53.988281 8.878906 52.988281 C 8.207031 51.902344 8.214844 51.113281 9.367188 49.5 C 9.605469 49.894531 9.398438 50.207031 9.265625 50.507812 C 8.59375 51.992188 8.984375 53.109375 10.460938 53.824219 C 10.839844 54.007812 11.25 54.125 11.832031 54.347656 Z M 11.835938 54.34375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bcac4e10b8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#572399a378)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a67dab4bf1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 42.046875 45.042969 C 41.144531 45.390625 40.246094 45.742188 39.269531 46.125 C 39.746094 45.421875 40.78125 44.96875 42.046875 45.042969 Z M 42.046875 45.042969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ceec40dc91)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3c6b8bf03e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4ccb3e5184)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 45.996094 51.457031 C 47.585938 51.214844 49.136719 50.785156 50.710938 50.457031 C 51.839844 50.222656 52.964844 49.960938 54.085938 49.6875 C 54.824219 49.511719 55.492188 49.179688 56.171875 48.816406 C 59.171875 47.21875 62.019531 45.378906 64.875 43.550781 C 65.757812 42.984375 66.683594 42.492188 67.769531 42.347656 C 68.203125 42.292969 68.605469 41.972656 69.007812 41.753906 C 69.375 41.550781 69.730469 41.320312 70.183594 41.046875 C 70.199219 41.457031 69.980469 41.550781 69.804688 41.65625 C 68.476562 42.460938 67.15625 43.265625 65.820312 44.054688 C 64.320312 44.941406 62.78125 45.769531 61.3125 46.710938 C 59.835938 47.65625 58.304688 48.484375 56.707031 49.1875 C 55.730469 49.621094 54.804688 50.09375 53.6875 50.226562 C 52.089844 50.414062 50.527344 50.875 48.949219 51.226562 C 47.984375 51.445312 47.011719 51.554688 46 51.453125 Z M 45.996094 51.457031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5810939f5f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dcb85c4fbf)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#281312c6c0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 53.945312 48.535156 C 52.546875 49.269531 47.800781 50.53125 47.007812 50.410156 C 49.28125 49.640625 51.589844 48.996094 53.945312 48.535156 Z M 53.945312 48.535156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4f088c359c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#23aed9de80)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b007fbd68d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 62.410156 43.679688 C 63.3125 42.761719 64.699219 42.996094 65.667969 42.234375 C 64.886719 43.382812 63.484375 43.179688 62.410156 43.679688 Z M 62.410156 43.679688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a65a903328)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e7aae47d17)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f1fa7aaab0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47dfd1",
    d: "M 71.433594 39.28125 C 70.375 39.34375 70.035156 40.230469 69.234375 40.609375 C 70.070312 39.199219 70.484375 38.921875 71.433594 39.28125 Z M 71.433594 39.28125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaturnTeal140X85Px);
export default __webpack_public_path__ + "static/media/Saturn Teal - (140 x 85px).69f74505ed3bcfe5ae041ba5d3a59185.svg";
export { ForwardRef as ReactComponent };